import React, { useState } from "react";
import { GetServerSidePropsContext, NextPage } from "next";
import Metadata from "containers/common/sections/Metadata";
import { Container } from "@material-ui/core";
import energy5Theme from "config/themes/energy5Theme";
import MainLayout from "containers/common/layouts/MainLayout";
import { createGetServerSideProps, ENV } from "evcharging/app";
import Spacer from "components/common/atoms/Spacer";
import RetailTopSection2 from "containers/retail/sections/compare-energy-rates/RetailTopSection2";
import RetailResultSection from "containers/retail/sections/compare-energy-rates/RetailResultSection";
import { CompareRatesResult } from "containers/retail/sections/compare-energy-rates/CompareRatesForm2";
import { I18nPage } from "i18n/types/pages.enum";

const CompareEnergyRates: NextPage = () => {
  const [resultProps, setResultProps] = useState<CompareRatesResult>(null);

  return (
    <>
      <Metadata />
      <MainLayout theme={energy5Theme}>
        <Container>
          {resultProps === null ? (
            <RetailTopSection2 onSubmitForm={setResultProps} />
          ) : (
            <RetailResultSection {...resultProps} />
          )}
        </Container>
        <Spacer value={113} />
      </MainLayout>
    </>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, async (context: GetServerSidePropsContext, locale) => {
  if (ENV.IS_PRODUCTION) {
    return {};
  }
  return {
    redirect: {
      destination: '/compare-energy-rates',
      permanent: false,
    },
  };
}, [I18nPage.CompareRates]);

export default CompareEnergyRates;
